import React, { PureComponent } from 'react';

class Swipe extends PureComponent {
  constructor(props) {
    super(props);
    
    this.state = {
      touchStartX: 0,
      prevTouchX: 0,
      beingTouched: false
    };
  }

  handleStart(clientX) {
    this.setState({
      touchStartX: clientX,
      beingTouched: true
    });
  }
  
  handleMove(clientX) {
    if (this.state.beingTouched) {
      const touchX = clientX;
      if (this.state.touchStartX > touchX) {
        this.props.handleSwipeRight();
      } else {
        this.props.handleSwipeLeft();
      } 
      this.setState({
        prevTouchX: touchX
      });
    }
  }
  
  handleEnd(event) {
    this.setState({
      touchStartX: 0,
      beingTouched: false
    });
  }
  
  handleTouchStart(touchStartEvent) {
    touchStartEvent.preventDefault();
    this.handleStart(touchStartEvent.targetTouches[0].clientX);
  }
  
  handleTouchMove(touchMoveEvent) {
    this.handleMove(touchMoveEvent.targetTouches[0].clientX);
  }
  
  handleTouchEnd(event) {
    this.handleEnd(event);
  }
  
  handleMouseDown(mouseDownEvent) {
    mouseDownEvent.preventDefault();
    this.handleStart(mouseDownEvent.clientX);
  }
  
  handleMouseMove(mouseMoveEvent) {
    this.handleMove(mouseMoveEvent.clientX);
  }
  
  handleMouseUp(event) {
    this.handleEnd(event);
  }
  
  handleMouseLeave() {
    this.handleMouseUp();
  }
  
  render() {
    return (
      <div
        style={{display:'contents'}}
        onTouchStart={touchStartEvent => this.handleTouchStart(touchStartEvent)}
        onTouchMove={touchMoveEvent => this.handleTouchMove(touchMoveEvent)}
        onTouchEnd={(touchEndEvent) => this.handleTouchEnd(touchEndEvent)}
        // The following event handlers are for mouse compatibility:
        onMouseDown={mouseDownEvent => this.handleMouseDown(mouseDownEvent)}
        onMouseMove={mouseMoveEvent => this.handleMouseMove(mouseMoveEvent)}
        onMouseUp={(mouseUpEvent) => this.handleMouseUp(mouseUpEvent)}
        onMouseLeave={() => this.handleMouseLeave()}
      >
          {this.props.children}
      </div>
    );
  }
}

export default Swipe;


// WEBPACK FOOTER //
// ./src/components/UI/Swipe/Swipe.js